import {
	Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges,
	SimpleChange, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { IpAddress, Device } from 'DiscoveryEngine.TS/Core';
import { ArrayUtils } from 'DiscoveryEngine.TS/Utils';
//import { IfTable, IfEntry } from 'DiscoveryEngine.TS/InfoSets';
import { ViewerDeviceFilterDto } from 'UvExplorerServer.Dtos.TS/Viewer';
import { MessageService } from 'base';
import { IfEntry } from 'DiscoveryEngine.TS/InfoSets/IfTable';


export class SnmpIfSelectorEntry {
	public dataKey: string;
	public ifIndex: string;
	public alias: string;
	public name: string;
	public description: string;
	public adminStatus: string;
	public operStatus: string;

	public ifIndexTag: number;
	public get hasIfIndexTag(): boolean {
		return (this.ifIndexTag !== undefined);
	}

	public ifTag: IfEntry;
	public get hasIfTag(): boolean {
		return !!this.ifTag;
	}

	constructor() {
		this.dataKey = "";
		this.ifIndex = "";
		this.alias = "";
		this.name = "";
		this.description = "";
		this.adminStatus = "";
		this.operStatus = "";

		this.ifIndexTag = undefined;
		this.ifTag = null;
	}
}


@Component({
	selector: 'snmpif-selector',
	templateUrl: './snmpifselector.component.html',
	styleUrls: ['./snmpifselector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnmpIfSelectorComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	public device: Device;

	@Input()
	public visible: boolean;

	@Input()
	public initialSelection: number[];

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<number[]>

	@Output()
	public onCancel: EventEmitter<any>;

	public entries: SnmpIfSelectorEntry[];
	public selectedEntries: any;

	constructor(private changeDetector: ChangeDetectorRef,
		private messageService: MessageService) {

		this.device = null;
		this.visible = false;
		this.initialSelection = [];
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<number[]>();
		this.onCancel = new EventEmitter<any>();

		this.entries = [];
		this.selectedEntries = [];
	}

	public doCustomSort(event): void {
		let comparer = function (a: SnmpIfSelectorEntry, b: SnmpIfSelectorEntry): number {
			let result = 0;

			switch (event.field) {
				case "ifIndex":
					if (a.hasIfIndexTag && b.hasIfIndexTag) {
						if (a.ifIndexTag < b.ifIndexTag) {
							result = -1;
						}
						else if (a.ifIndexTag > b.ifIndexTag) {
							result = 1;
						}
						else {
							result = 0;
						}
					}
					else if (a.hasIfIndexTag) {
						result = 1;
					}
					else if (b.hasIfIndexTag) {
						result = -1;
					}
					break;
				default:
					// Compare string fields
					result = a[event.field].localeCompare(b[event.field]);
					break;
			}

			return result * event.order;
		}

		this.entries.sort(comparer);
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}
	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		this.selectedEntries = [];

		change = changes["visible"];
		if (change) {
			if (this.visible) {
				this.rebuildEntries();
			}
		}
	}

	public ngOnDestroy(): void {

	}

	private rebuildEntries(): void {

		this.entries = [];
		this.selectedEntries = [];

		if (!!this.device && this.device.HasIfTable) {

			this.device.IfTable.ForEach((ifEntry: IfEntry) => {

				// Create entry
				let entry = new SnmpIfSelectorEntry();

				entry.dataKey = "" + ifEntry.IfIndex;
				entry.ifIndex = "" + ifEntry.IfIndex;
				entry.ifIndexTag = ifEntry.IfIndex;

				if (ifEntry.HasAlias) {
					entry.alias = ifEntry.Alias;
				}
				if (ifEntry.HasName) {
					entry.name = ifEntry.Name;
				}
				if (ifEntry.HasDescription) {
					entry.description = ifEntry.Description;
				}
				if (ifEntry.HasAdminStatus) {
					entry.adminStatus = ifEntry.AdminStatusToString();
				}
				if (ifEntry.HasOperStatus) {
					entry.operStatus = ifEntry.OperStatusToString();
				}

				entry.ifTag = ifEntry;

				this.entries.push(entry);

				// Select entry if it is in initialSelection
				if (this.initialSelection) {
					if (ArrayUtils.Contains(this.initialSelection, ifEntry.IfIndex)) {
						if (this.selectedEntries) {
							this.selectedEntries.push(entry);
						}
						else {
							this.selectedEntries = [ entry ];
						}
					}
				}
			});
		}
	}

	public onOkClicked(): void {	
		this.onOk.emit(this.getSelectedInterfaces());
		this.hide();
	}

	public onCancelClicked(): void {
		this.onCancel.emit();
		this.hide();
	}

	private getSelectedInterfaces(): number[] {
		let result: number[] = [];
		if (this.selectedEntries) {
			if (Array.isArray(this.selectedEntries)) {
				this.selectedEntries.forEach((entry: SnmpIfSelectorEntry) => {
					result.push(entry.ifIndexTag);
				}, this);
			}
			else {
				let entry = <SnmpIfSelectorEntry>this.selectedEntries;
				result.push(entry.ifIndexTag);
			}
		}
		return result;
	}

	public get totalInterfaceCount(): number {
		if (this.entries)
			return this.entries.length;
		else
			return 0;
	}

	public get selectedInterfaceCount(): number {
		if (this.selectedEntries) {
			if (Array.isArray(this.selectedEntries)) {
				return this.selectedEntries.length;
			}
			else {
				return 1;
			}
		}
		return 0;
	}
}
